import Vue from "vue";
export const RenderEventBus = new Vue();
